// extracted by mini-css-extract-plugin
module.exports = {"freshsales-contact-form":"freshsales-contact-form_freshsales-contact-form__6vwyW","fserv-field":"freshsales-contact-form_fserv-field__4xJlr"};